import React, { useState, useEffect } from "react";
import ContentLoader from "react-content-loader";
import { useNavigate } from "react-router-dom";
import { Get_Api } from "../../Api_Url";

const TopCountry = () => {
  const navigate = useNavigate();
  const [allCountry, setAllCountry] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  console.log(allCountry);
  const getAllCountry = async () => {
    try {
      setIsLoading(true);
      const response = await Get_Api(`api/admin/GetAllCountry`);
      setAllCountry(response?.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    getAllCountry();
  }, []);

  const destinationdetails = (name, id) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(`/destination/${name}`, { state: { id } });
  };

  return (
      <div className="Destination">
        <p>Country</p>
        <h2>Top Country</h2>
        <br />
        <br />
        <div className="top-dest-cards">
          {isLoading ? (
            <ContentLoader
              speed={2}
              width={600}
              height={400}
              viewBox="0 0 600 400"
              backgroundColor="#f3f3f3"
              foregroundColor="#ecebeb"
            >
              <rect x="484" y="38" rx="0" ry="0" width="4" height="6" />
              <rect x="242" y="39" rx="0" ry="0" width="166" height="119" />
              <rect x="58" y="36" rx="0" ry="0" width="166" height="119" />
              <rect x="427" y="37" rx="0" ry="0" width="166" height="119" />
              <rect x="60" y="179" rx="0" ry="0" width="166" height="119" />
              <rect x="244" y="179" rx="0" ry="0" width="166" height="119" />
              <rect x="426" y="177" rx="0" ry="0" width="166" height="119" />
            </ContentLoader>
          ) : (
            allCountry?.map((Destination, index) => (
              <div
                onClick={() => {
                  destinationdetails(Destination?.Name, Destination?._id);
                }}
                key={index}
                className="top-dest-card"
              >
                <img src={Destination?.Image} alt={Destination?.Name} />
                <div className="top-dest-text">
                  <h4>{Destination?.Name}</h4>
                  <p>{Destination?.Description}</p>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
  );
};

export default TopCountry;
